module.exports = __webpack_public_path__ + "static/cloudns.13e30806.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/customers/cloudns.png
// module id = 101
// module chunks = 35783957827783 169928946856436